module.exports = __webpack_public_path__ + "img/icon.4f58871f.png";